
import { Athlete } from "@/types/interface";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      user: {} as Athlete,
      mailTemplate: "",
    };
  },

  methods: {
    closeModal() {
      this.$emit("closeProblemModal");
    },

    async getUserInfos() {
      const athleteResponse = await axios.get(
        `/athletes/${this.$store.getters["auth/getAthleteId"]}`
      );

      if (athleteResponse.status < 300) {
        this.user = athleteResponse.data;
      }
    },

    async feelMailTemplate() {
      await this.getUserInfos();
      this.mailTemplate = `Bonjour,
Je rencontre un problème pour enregistrer ma carte VAvantages.
Voici mes informations:
- Pseudo: ${this.user.user.username}
- Nom: ${this.user.lastName}
- Prénom: ${this.user.firstName}
- Numéro de carte VA:

Merci d'avance pour votre aide.
      `;
    },

    mailURL() {
      return `mailto:overrun@24heures.org?subject=${encodeURI(
        "Problème lors de l'enregistement de la carte VAvantages"
      )}&body=${encodeURI(this.mailTemplate)}`;
    },
  },
  mounted() {
    this.feelMailTemplate();
  },
});
